/**
 * Крестик — один на всё приложение: закрыть лист, закрыть форму, убрать
 * строку, очистить поиск. Иконка Font Awesome, цвет от текста.
 */
import { Icon } from './icon.js';

export const CloseX = () => <Icon name="xmark" size={15} className="rcx" />;
